
import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroBanner from './components/HeroBanner';
import CompanyOverview from './components/CompanyOverview';
import Features from './components/Features';
import DistributorsShowcase from './components/DistributorsShowcase';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroBanner />
      <CompanyOverview />
      <Features />
      <DistributorsShowcase />
      <ContactCTA />
      <Footer />
    </div>
  );
}
